import { Component } from '@angular/core';
import { SectionHeadingComponent } from '../../ui/section-heading/section-heading.component';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [SectionHeadingComponent],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  items = [
    { q: 'Czy goście muszą coś instalować?', a: 'Nie. Skanują kod QR i grają w przeglądarce telefonu - bez kont, bez pobierania, bez rejestracji.', open: false },
    { q: 'Co jeśli ktoś nie chce grać?', a: 'Nic na siłę. Każdy uczestniczy ze swojego miejsca, kiedy ma ochotę. To właśnie cały sens czyli zero presji i żenady.', open: false },
    { q: 'Ile zajmuje przygotowanie?', a: 'Około 10 minut. Para młoda wybiera format, wpisuje pytania przez kreator i gotowe. Dostępne są też proponowane przez nas pytania do wyboru.', open: false },
    { q: 'Czy prowadzący musi znać się na technologii?', a: 'Nie. Dostaje gotowy scenariusz krok po kroku - co kliknąć i kiedy.', open: false },
    { q: 'Czy mogę użyć własnych pytań?', a: 'Tak. Możesz też użyć gotowych pytań lub połączyć oba warianty. Wystarczy wpisać je w kreatorze quizu.', open: false },
  ];

  toggle(i: number) {
    this.items[i].open = !this.items[i].open;
  }
}
